{
  "name": "nfon-sip-trunk",
  "version": "1.0.0",
  "commitInfo": "",
  "description": "NFON SIP Trunk",
  "license": "ISC",
  "main": "src/main.ts",
  "private": true,
  "scripts": {
    "ng": "ng",
    "prestart": "npm run build:clear",
    "tsc": "tsc",
    "tsc:w": "tsc -w",
    "clear-dist": "node clear-dist.js",
    "pack:tdev": "npm run build:tdev && node build-deb.js --env=tdev",
    "pack:prod": "npm run build:prod && node build-deb.js --env=prod",
    "compodoc": "compodoc -p src/tsconfig.json --theme readthedocs -n 'Web-Frontend' --hideGenerator -d ./documentation",
    "start": "ng serve --host 0.0.0.0",
    "start:secure": "ng serve --configuration=ssl-secure",
    "start:proxy": "npm start -- --proxy-config proxy.conf.json --configuration=proxy",
    "go": "npm i && npm start",
    "report:depgraph": "ts-depgraph && mv depgraph.* reports/depgraph",
    "clear:reports": "rimraf ./reports/**/* !.gitkeep",
    "stylelint": "stylelint",
    "prettier:write": "npx prettier --write .",
    "prettier:check": "npx prettier --check .",
    "lint": "concurrently 'npm:lint:*'",
    "lint:ng": "ng lint",
    "lint:scss": "stylelint \"**/*.scss\"",
    "lint-fix": "concurrently 'npm:lint-fix:*'",
    "lint-fix:ng": "npm run lint:ng -- --fix",
    "lint-fix:scss": "npm run lint:scss -- --fix",
    "lint-report": "concurrently 'npm:lint-report:*'",
    "lint-report:ng": "ng lint --format=junit --output-file reports/lint/ng.xml",
    "lint-report:scss": "npm run lint:scss --  --custom-formatter ./node_modules/stylelint-junit-formatter --output-file reports/lint/scss.xml",
    "test": "jest",
    "test-e2e": "cd E2E && npm run test",
    "test:coverage": "jest --coverage",
    "unit-test": "cross-env JEST_REPORT_FILE=./reports/unit-test/jest-bamboo-report.json jest",
    "unit-test:coverage": "npm run unit-test -- --coverage --coverageDirectory reports/unit-test/coverage",
    "unit-test:watch": "jest --watch",
    "pre-build": "concurrently 'npm:pre-build:*'",
    "pre-build:add-package-info": "sh ./scripts/add-package-info.sh",
    "pre-build:add-css-hash": "sh ./scripts/add-css-hash.sh",
    "build:prod": "cross-env ANGULAR_ENVIRONMENT=production scripts/build.sh",
    "build:test": "cross-env ANGULAR_ENVIRONMENT=test scripts/build.sh",
    "build-report": "source-map-explorer 'dist/nfon-sip-trunk/browser/*.js' --html reports/bundle/index.html",
    "build-serve": "cd ./dist/nfon-sip-trunk && angular-http-server -p 4200",
    "verify-svg-no-title-tag": "scripts/verify-svg-no-title-tag.sh",
    "verify-build": "concurrently 'npm:verify-build:*'",
    "verify-build:css-hash": "scripts/verify-css-hash.sh",
    "build:clear": "rimraf ./dist/* !.gitkeep",
    "build:clear:legacy": "rimraf ./dist/frontend/* !.git",
    "clean:maps": "find dist/ -name \"*.map\" -type f -delete"
  },
  "files": [
    "*.js",
    "build",
    "node_modules"
  ],
  "engines": {
    "node": ">= 20.19.1 <21"
  },
  "dependencies": {
    "@angular/animations": "20.3.3",
    "@angular/cdk": "20.2.7",
    "@angular/common": "20.3.3",
    "@angular/core": "20.3.3",
    "@angular/forms": "20.3.3",
    "@angular/material": "20.2.7",
    "@angular/router": "20.3.3",
    "@ngx-translate/core": "17.0.0",
    "angular-svg-icon": "19.1.1",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^26.2.0",
    "ngx-cookie-service": "20.1.0",
    "ngx-infinite-scroll": "^20.0.0",
    "ngx-logger": "5.0.12",
    "ngx-order-pipe": "3.0.0",
    "rxjs": "7.8.2",
    "util": "0.12.5",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "20.3.0",
    "@angular-eslint/eslint-plugin": "20.3.0",
    "@angular-eslint/eslint-plugin-template": "20.3.0",
    "@angular-eslint/schematics": "20.3.0",
    "@angular-eslint/template-parser": "20.3.0",
    "@angular/build": "20.3.4",
    "@angular/cli": "20.3.4",
    "@angular/compiler": "20.3.3",
    "@angular/compiler-cli": "20.3.3",
    "@angular/platform-browser": "20.3.3",
    "@angular/platform-browser-dynamic": "20.3.3",
    "@angular/platform-server": "20.3.3",
    "@babel/preset-env": "7.28.3",
    "@jest/globals": "30.2.0",
    "@ngneat/spectator": "21.0.1",
    "@types/file-saver": "2.0.7",
    "@types/jest": "30.0.0",
    "@types/keycloak-js": "^2.5.4",
    "@types/md5": "2.3.5",
    "@types/node": "24.7.0",
    "@types/rimraf": "3.0.2",
    "@types/yargs": "17.0.33",
    "@typescript-eslint/eslint-plugin": "8.46.0",
    "@typescript-eslint/parser": "8.46.0",
    "angular-http-server": "1.12.0",
    "autoprefixer": "10.4.21",
    "concurrently": "9.2.1",
    "cross-env": "10.1.0",
    "esbuild": "0.25.10",
    "eslint": "8.57.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-rxjs": "5.0.3",
    "git-last-commit": "1.0.1",
    "globby": "15.0.0",
    "husky": "^9.1.7",
    "jest": "29.7.0",
    "jest-auto-spies": "3.0.0",
    "jest-canvas-mock": "2.5.2",
    "jest-preset-angular": "14.6.1",
    "jwt-decode": "4.0.0",
    "mockdate": "3.0.5",
    "ng-mocks": "14.13.5",
    "postcss": "8.5.6",
    "prettier": "3.6.2",
    "recursive-copy": "2.0.14",
    "rimraf": "6.0.1",
    "source-map-explorer": "2.5.3",
    "stylelint": "16.25.0",
    "stylelint-config-standard-scss": "16.0.0",
    "stylelint-order": "7.0.0",
    "stylelint-scss": "6.12.1",
    "ts-depgraph": "0.6.7",
    "ts-jest": "29.4.4",
    "typescript": "5.9.3",
    "webpack-bundle-analyzer": "4.10.2",
    "webpack-dev-server": "5.2.2",
    "yargs": "18.0.0"
  }
}
